import React from 'react';
import {CompactPicker} from 'react-color';
import './CustomColorPicker.css';

export default function CustomColorPicker(props) {
  const {
    currentState: {color},
    onChange,
    expanded,
    onExpandEvent,
  } = props;

  const ColorModal = () => (
    <div
      className="color-picker-for-draft-editor__color-modal "
      onClick={e => e.stopPropagation()}
    >
      <CompactPicker
        display={expanded}
        color={color}
        onChangeComplete={c => onChange('color', c.hex)}
        colors={[
          '#9C9C9C',
          '#FFFFFF',
          '#F79186',
          '#FFD59C',
          '#FFEF82',
          '#D8EB98',
          '#A4DD00',
          '#ADF0EE',
          '#C2EEFF',
          '#CCEBFF',
          '#E3DEFF',
          '#FEF0F5',
          '#808080',
          '#EDEDED',
          '#F44E3B',
          '#FFAE42',
          '#FFE957',
          '#DBDF00',
          '#68BC00',
          '#68CCCA',
          '#88CFEB',
          '#76A6CC',
          '#C0B5FF',
          '#FFC2D8',
          '#4D4D4D',
          '#CCCCCC',
          '#D33115',
          '#E27300',
          '#FCC400',
          '#B0BC00',
          '#5B9C0B',
          '#0C797D',
          '#009CE0',
          '#375F8A',
          '#836EFF',
          '#DC447C',
          '#000000',
          '#ADADAD',
          '#9F0500',
          '#C45100',
          '#FB9E00',
          '#808900',
          '#184D32',
          '#045659',
          '#0062B1',
          '#173063',
          '#653294',
          '#A5305B',
        ]}
      />
    </div>
  );

  return (
    <div
      className="color-picker-for-draft-editor__container"
      aria-label="rdw-color-picker"
      aria-haspopup="true"
      aria-expanded={expanded}
    >
      <div className="rdw-option-wrapper" onClick={onExpandEvent}>
        <i className="fa fa-paint-brush" />
      </div>
      {expanded ? <ColorModal /> : undefined}
    </div>
  );
}
